export default {
  methods: {
    genCpaParams(cpa) {
      const {
        amount,
        currency_code,
        cap_period_seconds,
        cap_players_count,
        hold_seconds,
        conditions = [],
      } = cpa;
      const values = conditions.reduce((acc, item) => {
        if (item.name === 'player_activity') {
          acc[item.name] = item;
          return acc;
        }

        acc[`${item.name}_min`] = item.min_value;
        acc[`${item.name}_max`] = item.max_value;

        return acc;
      }, {});
      return {
        amount,
        currency_code,
        cap_period_seconds,
        cap_players_count,
        hold_seconds,
        ...values,
      };
    },
  },
};
